import { ISelectOption } from '@/components/form/fields/SelectField';
import { SelectMultipleField } from '@/components/form/fields/SelectMultipleField';
import { OutlineButton } from '@/components/shared/button/OutlineButton';
import { useFormContext } from 'react-hook-form';
import { FaPlus, FaMinus } from 'react-icons/fa';

type ICustomFieldProps = {
  projectData?: ISelectOption[];
  projectIdsData?: string[];
  customFieldTypeData?: string;
};

export const UpdateProjectForm: React.FC<ICustomFieldProps> = ({
  projectIdsData,
  projectData,
}) => {
  const form = useFormContext();

  const selectAll = () => {
    const data = projectData?.map(option => option.value);
    form.setValue('project_ids', data);
  };

  const deselectAll = () => {
    form.setValue('project_ids', []);
  };

  return (
    <div className="flex flex-col gap-4 mt-2">
      <SelectMultipleField
        name="project_ids"
        defaultValue={projectIdsData}
        label="Select Projects"
        placeholder="Project"
        options={projectData}
        isSearchable={true}
        hasRequiredAsterisk
      />

      <div className="flex justify-center gap-2">
        <OutlineButton icon={<FaPlus />} onClick={selectAll}>
          Select All
        </OutlineButton>
        <OutlineButton icon={<FaMinus />} onClick={deselectAll}>
          Deselect All
        </OutlineButton>
      </div>
    </div>
  );
};
